export const companyInfo = (bidType: number) => {
	//18位不重复随机数
	const randomNumber = String(
		Math.random() * 10000000 * new Date().getTime()
	).substring(0, 18)
	return {
		//公司基础信息 || 营业执照信息
		...(bidType !== 8 && {
			establish_date: '2015-04-01',
			...(bidType === 6 && {
				company_name: 'test company',
				country: 'USA',
				pop_city: 'Juneau',
				pop_district: 'Alaska',
				pop_register_no: '123456',
				postal_code: '410000',
				company_address: 'Juneau',
				pop_register_url:
					'https://ecompic0.hitv.com/business/202104131503576067.png',
			}),
			...(bidType !== 6 && {
				company_name: `测试公司名称${randomNumber.substring(0, 6)}`,
				business_license: randomNumber,
				address: ['北京', '北京市', '东城区'],
				license_address: '测试详细地址',
				registered_capital: 5000000,
				start_date: '2015-04-01',
				end_date: '2099-12-31',
				business_scope: '测试经营范围',
				license_url:
					'https://ecompic0.hitv.com/business/202104131503576067.png',
			}),
		}),

		//联系人信息
		person_name: '公司或个体名称',
		person_mobile: '18000000000',
		person_card_type: 1,
		person_idcard: randomNumber,
		business_contacts: '测试人员',
		business_contacts_phone: '18000000000',

		...((bidType === 2 || bidType === 3) && {
			cert_start_date: '2000-01-01',
			cert_end_date: '2099-12-31',
			idcard_due_url:
				'https://ecompic0.hitv.com/business/202104131503576067.png',
			idcard_back_url:
				'https://ecompic0.hitv.com/business/202104131503576067.png',
			authorize_url:
				'https://ecompic0.hitv.com/business/202104131503576067.png',
			finance_contacts: '测试人员',
			finance_contacts_phone: '18000000000',
			aftersale_contacts: '测试人员',
			aftersale_contacts_phone: '18000000000',
			deliver_contacts: '测试人员',
			deliver_contacts_phone: '18000000000',
		}),

		...(bidType === 6 && {
			person_email: 'info@mgtv.com',
			business_contacts_email: 'info@mgtv.com',
		}),

		...(bidType === 7 && {
			cert_start_date: '2000-01-01',
			cert_end_date: '2099-12-31',
			idcard_due_url:
				'https://ecompic0.hitv.com/business/202104131503576067.png',
			idcard_back_url:
				'https://ecompic0.hitv.com/business/202104131503576067.png',
			authorize_url:
				'https://ecompic0.hitv.com/business/202104131503576067.png',
			contact_front_url:
				'https://ecompic0.hitv.com/business/202104131503576067.png',
			contact_back_url:
				'https://ecompic0.hitv.com/business/202104131503576067.png',
		}),

		...(bidType === 8 && {
			cert_start_date: '2000-01-01',
			cert_end_date: '2099-12-31',
			idcard_due_url:
				'https://ecompic0.hitv.com/business/202104131503576067.png',
			idcard_back_url:
				'https://ecompic0.hitv.com/business/202104131503576067.png',
			authorize_url:
				'https://ecompic0.hitv.com/business/202104131503576067.png',
		}),

		// 其他信息
		company_email: 'info@mgtv.com',
		...((bidType === 2 || bidType === 3) && {
			company_region: ['北京', '北京市', '东城区'],
			company_address: '办公详细地址',
			industry: '电商',
			company_tel: '88888888',
			company_tel_area: '0731',
			company_type: ['1'],
		}),
		...(bidType === 6 && {
			industry: '电商',
			company_tel: '88888888',
			company_tel_area: '0731',
			company_type: ['1'],
			pop_contract_url:
				'https://ecompic0.hitv.com/business/202104131503576067.png',
			expire_date: '2025-01-01',
		}),

		...(bidType === 8 && {
			company_region: ['北京', '北京市', '东城区'],
			company_address: '办公详细地址',
			industry: '电商',
		}),
	}
}

export const financialInfo = (bidType: number) => {
	const randomNumber = String(
		Math.random() * 100000 * new Date().getTime()
	).substring(0, 9)
	return {
		...(bidType === 8 && {
			bank_account: randomNumber,
			bank_name: '中国工商银行支行',
			bank_simple_name: '中国工商银行',
			bank_province: '北京',
			bank_city: '北京市',
			bank_area: '东城区',
			bank_account_url:
				'https://ecompic0.hitv.com/business/20210414152425540087.png',
			bank_region: ['北京', '北京市', '东城区'],
		}),
	}
}

export const businessInfo = (bidType: number) => {
	const randomNumber = String(Math.random() * new Date().getTime()).substring(
		0,
		5
	)
	return {
		store_list: [
			{
				cat_list: [
					{
						id: 966,
						cname: '时尚摆件',
						fid: 965,
						rank: 3,
						points_rate: '10.00',
						cname_1: 'IP潮牌',
						cname_2: 'IP家居',
						cname_3: '时尚摆件',
						cat_id: 966,
					},
				],
				settle_type: 1,
				business_type: 0,
				sname: `小芒${randomNumber}`,
				store_type: 1,
				main_cate_id: 966,
			},
		],
	}
}
